import axios from "axios";
import authHeader from "./auth-header";
import ICategory from "../types/category.type";

const API_URL = `${process.env.REACT_APP_SERVER_URL}/category`;


export const getById = (id: string) => {
  return axios.get(API_URL + "/" + id, { headers: authHeader() });
};

export const create = (category: ICategory) => {
  return axios.post(API_URL, category, { headers: authHeader() });
};

export const update = (id: number, category: ICategory) => {
  return axios.put(API_URL + "/" + id, category, { headers: authHeader() });
};

export const getCategories = (params: {}) => {
  return axios.get(API_URL, { params: params, headers: authHeader() });
};

export const getActiveCategories = () => {
  return axios.get(API_URL + "/actives", { headers: authHeader() });
};
